// extracted by mini-css-extract-plugin
module.exports = {"imageStyle":"about_imageStyle__gnL0O","imageBox":"about_imageBox__9Vabl"};